// Signal emitted after any successful add/update/delete so other components
// (or the section itself) can trigger a refetch. Same pattern as the other
// v2 sections' events.js files.
export const FAM_V2_REFRESH = "fam-v2:refresh";

// Content column → editor rail: open the Add-relative form (3071:2760).
export const FAM_V2_ADD = "fam-v2:add";

// Content column → editor rail: open that SAME form prefilled for an edit.
// Payload `{ relative }` — the row whose relationship was clicked. The rail
// owns both flows now; the old centered RelativeModal is gone.
export const FAM_V2_EDIT = "fam-v2:edit";

// Transcript-mode re-edit of an already-staged captured item. Payload
// `{ captured, famv2Record }` — famv2Record is null for a staged-add
// row. Mirrors CC_V2_EDIT_CAPTURED / DX_V2_EDIT_CAPTURED.
export const FAM_V2_EDIT_CAPTURED = "fam-v2:edit-captured";
